import { render, staticRenderFns } from "./Ad2.vue?vue&type=template&id=399af58a&scoped=true"
import script from "./Ad2.vue?vue&type=script&lang=js"
export * from "./Ad2.vue?vue&type=script&lang=js"
import style0 from "./Ad2.vue?vue&type=style&index=0&id=399af58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399af58a",
  null
  
)

export default component.exports